import { render, staticRenderFns } from "./inputHeader.vue?vue&type=template&id=92c64fba&scoped=true"
import script from "./inputHeader.vue?vue&type=script&lang=js"
export * from "./inputHeader.vue?vue&type=script&lang=js"
import style0 from "./inputHeader.vue?vue&type=style&index=0&id=92c64fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c64fba",
  null
  
)

export default component.exports